import { Controller } from "@hotwired/stimulus"

// Toggle and open the contextual help manual overlay.
// Usage: data-controller="help" data-help-manual-value="admin|public"
export default class extends Controller {
  static values = {
    manual: { type: String, default: "public" },
  }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    const isTyping = event.target.matches("input, textarea, select, [contenteditable]")
    if (isTyping) return

    if (event.key === "?" && event.shiftKey) {
      event.preventDefault()
      this.open({ params: { section: this.manualValue === "admin" ? "shortcuts" : "welcome" } })
    }
  }

  toggle() {
    document.dispatchEvent(new CustomEvent("help-manual:toggle", {
      detail: { manual: this.manualValue },
    }))
  }

  open(event) {
    const section = event?.params?.section || event?.currentTarget?.dataset?.helpSection
    document.dispatchEvent(new CustomEvent("help-manual:open", {
      detail: { manual: this.manualValue, section },
    }))
  }
}
